import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { InputWithButton2, LinkDocument } from "..";
import { Row, Col } from "react-bootstrap";
import Image29 from "../../../assets/images/image29.png";
import { Search, Pin, ChevronRight } from "../../icons";
import { FindUsAPI } from "@api";
import { useState } from "react";
import { useEffect } from "react";
import "./MeetUsSection.scss";

const SecondSection = styled.div`
  position: relative;
`;

const SecondSectionImage = styled.img`
  position: absolute;
  bottom: -4px;
  right: 1.5em;
  height: 110%;
  width: auto;
`;

const MeetUsSection = () => {
  const [location, setLocation] = useState(null);
  const [search, setSearch] = useState("");
  const [isSearch, setIsSearch] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const loadData = async () => {
      const result = await FindUsAPI({
        limit: 4,
        page: 1,
        search: search,
      });

      const locationData =
        result.data.code !== 404 ? result.data.data.result : [];
      setLocation(locationData);
    };

    if (!location) {
      loadData();
    }

    if (isSearch) {
      loadData();
      setIsSearch(false);
    }
  }, [location, isSearch, search]);

  const doSearch = () => {
    setIsSearch(true);
  };
  return (
    <div className="meet-us-section">
      <h4 className="title">{t("find_us")}</h4>
      <div className="body">
        <SecondSection>
          <div className="content-box">
            <Row>
              <Col xs="12" md="8">
                <div className="form-box">
                  <InputWithButton2
                    icon={Search}
                    placeholder={`${t('contoh')} : Jakarta, Senayan`}
                    buttonLabel={t("search")}
                    value={search}
                    setValue={setSearch}
                    doFunction={doSearch}
                  />
                </div>

                <div className="color-brown d-flex align-items-center atm-branch">
                  <Pin className="color-brown" /> <span>{t("atm_branch")}</span>
                </div>
                <div className="atm-card-box">
                  {location != null ? (
                    location.length > 0 ? (
                      location.map((data, i) => {
                        return (
                          <div className="atm-card-item" key={i}>
                            <LinkDocument
                              label={data.type === "atm" ? t("atm") : t("cabang")}
                              labelIconFalse
                              title={data.title}
                              linkLabel={t("lihat_peta")}
                              linkIcon={ChevronRight}
                              linkRedirect={data.location}
                              rowLine="1"
                            />
                          </div>
                        );
                      })
                    ) : (
                      <p className="text-start">{t("no_atm_branch")}</p>
                    )
                  ) : (
                    ""
                  )}
                </div>
              </Col>
            </Row>
          </div>
          <SecondSectionImage
            className="d-none d-xl-block"
            width="80%"
            src={Image29}
          />
        </SecondSection>
      </div>
    </div>
  );
};

export default MeetUsSection;
